module.exports = {
  __init__: [ 'selectionVisuals', 'selectionBehavior' ],
  __depends__: [
    require(108),
    require(141)
  ],
  selection: [ 'type', require(156) ],
  selectionVisuals: [ 'type', require(158) ],
  selectionBehavior: [ 'type', require(157) ]
};
